import { useEffect, useRef } from "react";

export default function Cursor() {
    const dot = useRef(null);
    const ring = useRef(null);

    useEffect(() => {
        if (!window.matchMedia("(pointer: fine)").matches) return undefined;
        document.documentElement.classList.add("vera-cursor");
        let x = window.innerWidth / 2;
        let y = window.innerHeight / 2;
        let rx = x;
        let ry = y;
        let raf;
        const onMove = (e) => {
            x = e.clientX;
            y = e.clientY;
            if (dot.current) dot.current.style.transform = `translate(${x}px, ${y}px)`;
            const t = e.target;
            if (ring.current) {
                if (t.closest && t.closest("a, button, [role='button'], [data-hover]")) ring.current.classList.add("is-hover");
                else ring.current.classList.remove("is-hover");
            }
        };
        const loop = () => {
            rx += (x - rx) * 0.16;
            ry += (y - ry) * 0.16;
            if (ring.current) ring.current.style.transform = `translate(${rx}px, ${ry}px)`;
            raf = requestAnimationFrame(loop);
        };
        window.addEventListener("mousemove", onMove, { passive: true });
        raf = requestAnimationFrame(loop);
        return () => {
            window.removeEventListener("mousemove", onMove);
            cancelAnimationFrame(raf);
            document.documentElement.classList.remove("vera-cursor");
        };
    }, []);

    return (
        <div aria-hidden="true">
            <div ref={dot} className="cursor-dot" data-testid="custom-cursor-dot" />
            <div ref={ring} className="cursor-ring" />
        </div>
    );
}
